import { Listing } from '@reverbdotcom/commons/src/rql';

export enum ActionType {
  SET_LISTING = 'setListing',
  SET_LOADING_LISTING = 'setLoadingListing',
  SHOW_TOAST = 'showToast',
  HIDE_TOAST = 'hideToast',
}

interface IAction {
  type: ActionType;
  payload?: any;
}

export interface ICardState {
  listing: Listing,
  loadingListing: boolean,
  toast: {
    isOpen: boolean;
    message?: string;
    isSuccess?: boolean;
  };
}

function sellerListingCardReducer(state: ICardState, action: IAction) {
  switch (action.type) {
    case ActionType.SET_LISTING:
      return {
        ...state,
        listing: action.payload.listing,
      };
    case ActionType.SET_LOADING_LISTING:
      return {
        ...state,
        loadingListing: action.payload.loadingListing,
      };
    case ActionType.SHOW_TOAST:
      return {
        ...state,
        toast: {
          isOpen: true,
          message: action.payload.message,
          isSuccess: action.payload.isSuccess,
        },
      };
    case ActionType.HIDE_TOAST:
      return { ...state, toast: { isOpen: false } } ;
    default:
      return { ...state };
  }
}

export default sellerListingCardReducer;
